import { Component, Input, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MenuIconTypes } from '../main-icon/main-icon.component';

@Component({
  selector: 'bepatient-dynamic-menu-secondary-button',
  templateUrl: './secondary-button.component.html',
  styleUrls: ['./secondary-button.component.scss'],
  standalone: false
})
export class SecondaryButtonComponent {
  private sanitizer = inject(DomSanitizer);

  @Input() label: string;
  @Input() icon: MenuIconTypes;
  @Input() color = 'var(--ion-color-dark)';
  @Input() selected: boolean;

  defaultColor = this.sanitizer.bypassSecurityTrustStyle(
    'var(--ion-color-dark)'
  );
}
